import React from "react";
import "./contact.css";

const Contact =()=> {
  return (
    <section id="contact" className="contact">
      <h2>Contacto</h2>
      <p>Puedes comunicarte conmigo a través de los siguientes medios:</p>
      <div className="contact-info">
        <p>LinkedIn: <a href="https://www.linkedin.com/in/johandry-perez-sanchez/" target="_blank" rel="noopener noreferrer">johandry perez-sanchez/</a></p>
        <p>GitHub: <a href="https://github.com/johandry-developer" target="_blank" rel="noopener noreferrer">github.com/johandry-developer</a></p>
        <p>Whatsapp +58 (412) 243.61.19</p>
      </div>
    </section>
  );
}

export default Contact;